// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609170304/js/" + chunkId + "." + {"44":"aa26d59a","225":"7009f4ec","481":"a80e0770","486":"011958a9","770":"6de8465f"}[chunkId] + ".0.17149971458676405.chunk.js";
};